import React from 'react';

import type {
    LumappsComponentProperties,
    MicroAppsComponentSettings,
    MicroAppsInputVariables,
} from '@lumapps/micro-apps/types';

import { LumappsComponentType } from '../../constants';
import { getLumappsComponentSettings } from '../LumappsComponent/LumappsComponent';

/**
 * Props for the LumAppsComponentSettings component.
 */
export interface LumAppsComponentSettingsProps<
    T extends LumappsComponentType = LumappsComponentType,
    S extends MicroAppsComponentSettings = MicroAppsComponentSettings,
    I extends MicroAppsInputVariables = MicroAppsInputVariables,
> {
    /**
     * The list of component properties to render.
     */
    componentsProperties: LumappsComponentProperties<T, S>[];
    /**
     * The current input variable values for the micro-app, typically used to pre-fill settings.
     */
    inputVariables?: I;
}

/**
 * Renders a list of LumApps component settings based on the provided configuration.
 * It dynamically renders the settings components based on their type.
 */
export const LumAppsComponentSettings: React.FC<LumAppsComponentSettingsProps> = ({
    componentsProperties,
    inputVariables,
}) => (
    <>
        {componentsProperties.map((componentSettings) => {
            const component = getLumappsComponentSettings(componentSettings.type);
            const { settings: Component } = component;

            return Component ? (
                <Component
                    key={componentSettings.type}
                    componentProperties={componentSettings}
                    inputVariables={inputVariables}
                />
            ) : null;
        })}
    </>
);
